export default __webpack_public_path__ + "static/logo-e401b89b0f0fe1ac10359f23dc465548.png";